module.exports = __webpack_public_path__ + "static/media/023.36a10fcb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/people/thumbs/023.jpg
// module id = 370
// module chunks = 0